export const errorsIreland = {
  postcode_error_title: 'Invalid Eircode',
  postcode_error_subtitle: 'Unfortunately, this Eircode could not be found.',
}
